import service from '@/utils/request';
export var getStationsCounter = function getStationsCounter(data) {
  return service({
    url: '/data/stat/stations',
    method: 'get',
    data: data
  });
};
export var getTotalCounter = function getTotalCounter(data) {
  return service({
    url: '/data/stat/dayGroup',
    method: 'post',
    data: data
  });
};
export function getMonthTotalCounter(data) {
  return service({
    url: '/data/stat/monthGroup',
    method: 'post',
    data: data
  });
}
export function getStationSoldDistributionCounter(data) {
  return service({
    url: '/data/stat/stationSoldDistribution',
    method: 'post',
    data: data
  });
}
export function getStationOilDiscountCounter(data) {
  return service({
    url: '/data/stat/stationOilDiscount',
    method: 'post',
    data: data
  });
}
export function getStationPayDistributionCounter(data) {
  return service({
    url: '/data/stat/stationPayDistribution',
    method: 'post',
    data: data
  });
}
export function getStationDiscountCapitalCounter(data) {
  return service({
    url: '/data/fc/stationDiscountCapital',
    method: 'post',
    data: data
  });
}
export function getMonthTargetCounter(params) {
  return service({
    url: '/data/stat/monthTarget',
    method: 'get',
    params: params
  });
}
export function addMonthTargetCounter(data) {
  return service({
    url: '/data/stat/monthTarget',
    method: 'post',
    data: data
  });
}
export function deleteMonthTargetCounter(data) {
  return service({
    url: '/data/stat/monthTarget',
    method: 'delete',
    data: data
  });
}
export function getShopMonthStatCounters(params) {
  return service({
    url: '/data/fc/shopMonthStat',
    params: params,
    method: 'get'
  });
}
export function getStationDailyRiskCounters(params) {
  return service({
    url: '/data/fc/dailyRisk',
    params: params,
    method: 'get'
  });
}
export function getStationDailyCounters(params) {
  return service({
    url: '/data/fc/dailyRecord',
    params: params,
    method: 'get'
  });
}
export function getStationDailyPlatformData(params) {
  return service({
    url: '/data/fc/dailyPlatform',
    params: params,
    method: 'get'
  });
}
export function getFinancialAllinList(params) {
  return service({
    url: '/data/fc/financialAllinList',
    params: params,
    method: 'get'
  });
}
export function getFinancialAllinRatio(params) {
  return service({
    url: '/data/fc/financialAllinRatio',
    params: params,
    method: 'get'
  });
}
export function createFinancialAllinRatio(params) {
  return service({
    url: '/daily/ratio/submit',
    data: params,
    method: 'post'
  });
}
export function getFinancialBankInCounters(params) {
  return service({
    url: '/data/fc/financialBankIn',
    params: params,
    method: 'get'
  });
}
export function getBillListData(name, sellerId, start, end, page, pageSize) {
  var mainOrderNo = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : '';
  var billType = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : 0;
  var sellerOrderType = arguments.length > 8 && arguments[8] !== undefined ? arguments[8] : 0;
  var beginId = arguments.length > 9 && arguments[9] !== undefined ? arguments[9] : 0;
  var shiftDate = arguments.length > 10 && arguments[10] !== undefined ? arguments[10] : '';
  var isSan = 0;

  if (name === 'sanOrderFbiData') {
    isSan = 1;
  } else if (name === 'sanRechargeFbiData') {
    isSan = 2;
  } else if (name === 'adminSvcOptData') {
    isSan = 11;
  }

  return service({
    url: '/data/fc/userOrderFbi',
    method: 'post',
    data: {
      name: name,
      sellerId: sellerId,
      isSan: isSan,
      shiftDate: shiftDate,
      startDate: start,
      endDate: end,
      page: page,
      pageSize: pageSize,
      mainOrderNo: mainOrderNo,
      billType: billType,
      sellerOrderType: sellerOrderType,
      beginId: beginId
    }
  });
}
export function getStationShiftCounters(params) {
  return service({
    url: '/data/fc/shiftRecord',
    params: params,
    method: 'get'
  });
}
export function createStationShiftCashierData(data) {
  return service({
    url: '/shift/info/submit',
    data: data,
    method: 'post'
  });
}
export function createStationDailyCashierData(data) {
  return service({
    url: '/shift/daily/submit',
    data: data,
    method: 'post'
  });
}
export function createStationDailyPlatformData(data) {
  return service({
    url: '/daily/platform/submit',
    data: data,
    method: 'post'
  });
}